import React, { useContext, useRef } from 'react';

import useInput from '../hooks/useInput';

import Container from '@mui/system/Container';

import { Box, Button, Typography, Modal, TextField } from '@mui/material';

import AuthContext from '../contexts/AuthContext';
import PageContext from '../contexts/PageContext';

export default function LoginModal(props = {}) {
  const authContext = useContext(AuthContext);
  const pageContext = useContext(PageContext);

  const emailInputRef = useRef();
  const passwordInputRef = useRef();

  const isNotEmpty = (value) => !value || value.trim() !== '';
  const isEmail = (value) => !value || value.includes('@');

  const handleSignUpModalOpen = () => {
    props.handleLoginClose();
    props.handleSignUpOpen();
  }

  const {
    value: passwordValue,
    isValid: passwordIsValid,
    hasError: passwordHasError,
    valueChangeHandler: passwordChangeHandler,
    valueTouchHandler: passwordTouchHandler,
    valueErrorHandler: passwordErrorHandler,
    inputBlurHandler: passwordBlurHandler,
    reset: resetPassword,
  } = useInput(isNotEmpty);
  const {
    value: emailValue,
    isValid: emailIsValid,
    hasError: emailHasError,
    valueChangeHandler: emailChangeHandler,
    valueTouchHandler: emailTouchHandler,
    valueErrorHandler: emailErrorHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmail,
  } = useInput(isEmail);

  let formIsValid = false;

  if (emailIsValid && passwordIsValid) {
    formIsValid = true;
  }

  const submitHandler = async (event) => {
    event.preventDefault();

    if (formIsValid) {
      const state = await authContext.onLogin(emailValue, passwordValue);
      if (state) {
        props.handleLoginClose();
        resetPassword();
        resetEmail();
        pageContext.onSetOrders();
      } else {
        passwordErrorHandler();
        emailErrorHandler();
      }
      //setLoginFail(authContext.onLogin(emailValue, passwordValue));
    } else {
      return;
    } //else if (!emailIsValid) {
      //#region emailInputRef.current.focus();
    //} else {
      //passwordInputRef.current.focus();
    //}
  };

  const passwordEnablesEmail = (event) => {
    emailTouchHandler();
    passwordChangeHandler(event);
  }

  const logoutHandler = () => {
    authContext.onLogout();
    pageContext.onReset();
  }

  return (
    <div>
      { !authContext.isLoggedIn && <Button color="inherit" onClick={props.handleLoginOpen}>Login</Button> }
      { authContext.isLoggedIn && <Button color="inherit" onClick={logoutHandler}>Logout</Button> }
      <Modal
        open={props.loginOpen}
        onClose={props.handleLoginClose}
        aria-labelledby="login-modal-title"
        aria-describedby="login-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4
        }}>
          <div>
            <Typography id="login-modal-title" level="h4" component="h1"><b>Welcome!</b></Typography>
            <Typography id="login-modal-description" level="body2" sx={{ mt: 1 }}>Sign in to continue</Typography>
          </div>
          <form onSubmit={submitHandler}>
            <Container 
              sx={{ flexDirection: "row", display: "flex" }}
            >
              <TextField
                ref={emailInputRef}
                name="email"
                type="email"
                placeholder="johndoe@email.com"
                label="Email"
                sx={{ mt: 3 }}
                value={emailValue}
                onChange={emailChangeHandler}
                onBlur={passwordBlurHandler}
                error={emailHasError}
                helperText={emailHasError && "Invalid credentials."}
              />
              <TextField
                ref={passwordInputRef}
                name="password"
                type="password"
                placeholder="password"
                label="Password"
                sx={{ mt: 3 }}
                value={passwordValue}
                onChange={passwordEnablesEmail}
                onBlur={emailBlurHandler}
                error={passwordHasError}
              />
            </Container>
            <Container 
              sx={{ mt: 2, flexDirection: "row-reverse", display: "flex" }}
            >
              <Button sx={{ mt: 1 }} type="submit" disabled={!formIsValid}>Log in</Button>
              <Typography
                fontSize="sm"
                sx={{ mt: 1.5, mr: 1 }}
                onClick={handleSignUpModalOpen}
              >
                Don't have an account?
              </Typography>
            </Container>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
